import { render, staticRenderFns } from "./ImageExtended.vue?vue&type=template&id=715e2fd4"
import script from "./ImageExtended.vue?vue&type=script&lang=js"
export * from "./ImageExtended.vue?vue&type=script&lang=js"
import style0 from "./ImageExtended.vue?vue&type=style&index=0&id=715e2fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports